export const ApplicationConstant = {
    ApplicationID : 15,
    clientId : 10,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
